import ajax from "@/libs/Ajax";
import config from "@/config";

export default async app => {
    let resp = await ajax.get('/ClientController/init');
   if(resp.isSenior === null){
     this.$router.push("/login");
   }
   console.log("resp",resp)
    app.$config.isSinglePage = !resp.isSenior;
    app.$config.version = resp.version;
    if (config && localStorage.getItem('isPgswitch') && localStorage.getItem('isPgswitch') === '2') {
        app.$config.title = '';
        app.$config.logo = '';
        app.$config.companyInfo = '';
        app.$config.version = '';
    }
}